import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesSushiLunchService } from "../../../shared/services";
import { IRulesSushiLunch } from "../../../redux/@types/rulesSushiLunch";

export const useUpdateStatusRulesSushiLunch = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const updateStatus = async (value: "active" | "inactive", id: any) => {
    if (isLoading) return;
    setIsLoading(true);
    await rulesSushiLunchService
      .patch(id, {
        status: value,
      })
      .then((res: Partial<IRulesSushiLunch>) => {
        setIsLoading(false);
        notify.success(
          `Se ha actualizado con éxito el estado de la regla con id: ${res.id}`
        );
      })
      .catch((err: any) => {
        setIsLoading(false);
        notify.error(err.message);
      });
  };

  return {
    isLoading,
    updateStatus,
  };
};
